import { useEffect, useState } from "react";
import { ReactSVG } from "react-svg";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const RegisterContent = () => {

    const navigate = useNavigate();

    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [mobile, setMobile] = useState("");

    useEffect(() => {
        
        const saved = localStorage.getItem("convertMobile");

        if (!saved) return;

        try {
            const obj = JSON.parse(saved);

            // شرایط لازم:
            // ۱. login === false
            // ۲. mobile وجود داشته باشد و خالی نباشد
            if (obj?.login === false && obj?.mobile) {

                // تبدیل اعداد فارسی به انگلیسی (ضد‌خطا)
                const convertFaToEn = (str) => {
                    const fa = "۰۱۲۳۴۵۶۷۸۹";
                    const en = "0123456789";
                    return str.replace(/[۰-۹]/g, (d) => en[fa.indexOf(d)]);
                };

                const phone = convertFaToEn(obj.mobile.toString()).replace(/[^0-9]/g, "");

                setMobile(phone);
            }

        } catch (err) {
            // اگر JSON خراب بود کاری نکنیم
        }
    }, []);

    // جلوگیری از چند toast همزمان
    const showToast = (msg, type = "error") => {
        toast.dismiss();
        toast[type](msg);
    };

    // تبدیل اعداد فارسی به انگلیسی
    const convertFaToEn = (str) => {
        const fa = "۰۱۲۳۴۵۶۷۸۹";
        const en = "0123456789";

        return str.replace(/[۰-۹]/g, (d) => en[fa.indexOf(d)]);
    };

    const normalizePersianText = (value) => {
        return value.replace(/[^آ-ی\s]/g, "");
    };

    // فقط عدد برای موبایل
    const handleMobileChange = (e) => {

        let value = convertFaToEn(e.target.value);

        // حذف هرچیز غیر از عدد
        value = value.replace(/[^0-9]/g, "");

        setMobile(value);
    };

    // جلوگیری از عدد در نام
    const validateName = (name) => {
        return !/[0-9]/.test(name);
    };

    const handleFirstNameChange = (e) => {

        const input = e.target.value;

        // اگر کاراکتر انگلیسی وارد شود
        if (/[a-zA-Z]/.test(input)) {
            if (!toast.isActive()) {
                showToast("نام خود را به فارسی وارد کنید");
            }
        }

        const value = normalizePersianText(input);
        setFirstName(value);
    };

    const handleLastNameChange = (e) => {

        const input = e.target.value;

        if (/[a-zA-Z]/.test(input)) {
            if (!toast.isActive()) {
                showToast("نام خانوادگی خود را به فارسی وارد کنید");
            }
        }

        const value = normalizePersianText(input);
        setLastName(value);
    };

    // اعتبارسنجی دقیق نام و نام خانوادگی
    const validatePersianName = (name) => {
        return /^[آ-ی\s]+$/.test(name.trim());
    };

    const handleRegister = async () => {

        const fName = firstName.trim();
        const lName = lastName.trim();
        const phone = mobile.trim();

        // validations
        if (!fName) {
            showToast("نام نمی‌تواند خالی باشد");
            return;
        }

        if (!validateName(fName)) {
            showToast("نام نمی‌تواند دارای عدد باشد، لطفا صحیح وارد کنید");
            return;
        }

        if (!lName) {
            showToast("نام خانوادگی نمی‌تواند خالی باشد");
            return;
        }

        if (!validateName(lName)) {
            showToast("نام خانوادگی نمی‌تواند دارای عدد باشد، لطفا صحیح وارد کنید");
            return;
        }

        if (!phone) {
            showToast("شماره موبایل نمی‌تواند خالی باشد");
            return;
        }

        if (phone.length < 11) {
            showToast("شماره موبایل باید ۱۱ رقم باشد");
            return;
        }

        if (!phone.startsWith("09")) {
            showToast("شماره موبایل معتبر نیست");
            return;
        }

        // بررسی OTP قبلی
        const otpData = JSON.parse(localStorage.getItem("otp"));

        if (otpData?.otpSended === true) {

            const lastSend = new Date(otpData.otpSendTime).getTime();
            const now = Date.now();
            const diff = now - lastSend;

            const ONE_MINUTE = 60 * 1000;

            if (diff < ONE_MINUTE && otpData.phone === phone) {
                navigate("/auth/otp");
                return;
            }
        }

        try {

            await axios.post(
                "https://my-sarad-back.liara.run/api/auth/register",
                {
                    // firstName: fName,
                    // lastName: lName,
                    phone: mobile,
                }
            );

            // ذخیره otp
            localStorage.setItem(
                "otp",
                JSON.stringify({
                    otpSended: true,
                    otpSendTime: new Date().toISOString(),
                    login: false,
                    phone: phone,
                    firstName: fName,
                    lastName: lName
                })
            );

            showToast("کد با موفقیت برای شما ارسال شد", "success");

            navigate("/auth/otp");

        } catch (err) {
            showToast(err?.response?.data?.message || "ارسال کد با خطا مواجه شد");

        }
    };

    return (
        <div className="mt-8 space-y-6">

            {/* نام */}
            <div className="space-y-1">
                <label className="text-[15px] text-slate-600">
                    نام خود را وارد کنید
                </label>

                <input
                    type="text"
                    value={firstName}
                    onChange={handleFirstNameChange}
                    placeholder="مثلا فاطمه"
                    className="
                    w-full
                    rounded-lg
                    border
                    border-slate-300
                    bg-slate-200
                    px-4
                    py-3
                    text-sm
                    outline-none
                    transition
                    focus:border-third
                    "
                />
            </div>

            {/* نام خانوادگی */}
            <div className="space-y-1">
                <label className="text-[15px] text-slate-600">
                    نام خانوادگی خود را وارد کنید
                </label>

                <input
                    type="text"
                    value={lastName}
                    onChange={handleLastNameChange}
                    placeholder="مثلا کریمی"
                    className="
                    w-full
                    rounded-lg
                    border
                    border-slate-300
                    bg-slate-200
                    px-4
                    py-3
                    text-sm
                    outline-none
                    transition
                    focus:border-third
                    "
                />
            </div>

            {/* موبایل */}
            <div className="space-y-1">

                <label className="text-[15px] text-slate-600">
                    شماره تماس خود را وارد کنید
                </label>

                <div className="relative">

                    <input
                        type="tel"
                        value={mobile}
                        onChange={handleMobileChange}
                        placeholder="مثلا 09123456789"
                        maxLength={11}
                        className="
                        w-full
                        rounded-lg
                        border
                        placeholder:pr-8
                        placeholder:text-right
                        border-slate-300
                        bg-slate-200
                        px-4
                        py-3
                        text-sm
                        outline-none
                        transition
                        focus:border-third
                        "
                    />

                    <div className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400">
                        <ReactSVG src={`${process.env.PUBLIC_URL}/assets/images/icons/mobile.svg`} className="w-6 h-6 -scale-x-100"/>
                    </div>

                </div>

            </div>

            {/* button */}
            <button
                onClick={handleRegister}
                className="
                w-full
                block
                bg-primary
                text-white
                text-sm
                font-medium
                py-3.5
                rounded-lg
                transition
                hover:opacity-90
                active:scale-[0.98]
                shadow-sm
                "
            >
                ثبت نام و رزرو وقت
            </button>

        </div>
    );
};

export default RegisterContent;